export const GET_TOKEN_SUCCESS = "GET_TOKEN_SUCCESS";
export const REMOVE_TOKEN_SUCCESS = "REMOVE_TOKEN_SUCCESS";

